export enum YmGoalHeader {
  CartButtonClick = 'headerCartButtonClick',
  DoctorsButtonClick = 'headerDoctorsButtonClick',
  OrganizationsButtonClick = 'headerOrganizationsButtonClick',
  FranchisingButtonClick = 'headerFranchisingButtonClick',
  SelectCityClick = 'headerSelectCityClick',
  LoginLkk = 'headerLoginLkk',
  UserNickButtonClick = 'headerUserNickButtonClick',
}
